// adminApi
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export function getAdminToken() {
  return localStorage.getItem('adminToken');
}

function authHeaders(extra = {}) {
  const t = getAdminToken();
  const h = { ...extra };
  if (t) h.Authorization = `Bearer ${t}`;
  return h;
}

export async function fetchAdminMe() {
  const response = await fetch(`${API_BASE_URL}/admin/me`, {
    headers: authHeaders(),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка');
  }
  return data;
}

export async function adminLogin(password, login = '') {
  const response = await fetch(`${API_BASE_URL}/admin-login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ password, login: login.trim() }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка авторизации');
  }

  return data;
}

export async function blockUser(userId) {
  const response = await fetch(`${API_BASE_URL}/block-user/${userId}`, {
    method: 'POST',
    headers: authHeaders(),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при блокировке пользователя');
  }

  return data;
}

export async function unblockUser(userId) {
  const response = await fetch(`${API_BASE_URL}/unblock-user/${userId}`, {
    method: 'POST',
    headers: authHeaders(),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при разблокировке пользователя');
  }

  return data;
}

// Получить все слоты (включая забронированные и свободные)
export async function getAllSlots() {
  const response = await fetch(`${API_BASE_URL}/all-slots`, {
    headers: authHeaders(),
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при получении слотов');
  }

  return data;
}

// Получить всех пользователей
export async function getAllUsers() {
  const response = await fetch(`${API_BASE_URL}/users`, {
    headers: authHeaders(),
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при получении пользователей');
  }
  return data;
}

export async function createSlots(untilDate) {
  const response = await fetch(`${API_BASE_URL}/create-slots`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ untilDate }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при создании слотов');
  }

  return data;
}

export async function getAllTracks() {
  const response = await fetch(`${API_BASE_URL}/media-list`, {
    headers: authHeaders(),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при получении списка треков');
  }

  return data;
}

/** Настройки (Zoom и др.) */
export async function getSettings() {
  const response = await fetch(`${API_BASE_URL}/admin/settings`, {
    headers: authHeaders(),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при получении настроек');
  }
  return data;
}

export async function saveSettings({ zoomLink, zoomMeetingId, zoomPasscode }) {
  const response = await fetch(`${API_BASE_URL}/admin/settings`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ zoomLink, zoomMeetingId, zoomPasscode }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при сохранении настроек');
  }
  return data;
}

export async function uploadFinalSlideImage(file) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch(`${API_BASE_URL}/admin/final-slide/image`, {
    method: 'POST',
    headers: authHeaders(),
    body: formData,
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка загрузки изображения');
  }
  return data;
}

export async function saveFinalSlideVisibility(enabled) {
  const response = await fetch(`${API_BASE_URL}/admin/final-slide/visibility`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ enabled: !!enabled }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка сохранения');
  }
  return data;
}

export async function uploadFinalSlideTrack(file) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch(`${API_BASE_URL}/admin/final-slide/track`, {
    method: 'POST',
    headers: authHeaders(),
    body: formData,
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка загрузки трека');
  }
  return data;
}

export async function deleteFinalSlideImage() {
  const response = await fetch(`${API_BASE_URL}/admin/final-slide/image`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка');
  }
  return data;
}

export async function deleteFinalSlideTrack() {
  const response = await fetch(`${API_BASE_URL}/admin/final-slide/track`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка');
  }
  return data;
}

/** Заменить аудиофайл на бэке (сохраняется то же имя). FormData: category, filename, file. */
export async function uploadMediaReplace(category, filename, file) {
  const formData = new FormData();
  formData.append('category', category);
  formData.append('filename', filename);
  formData.append('file', file);

  const response = await fetch(`${API_BASE_URL}/admin/media-replace`, {
    method: 'POST',
    headers: authHeaders(),
    body: formData,
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при замене файла');
  }
  return data;
}

/** Новый трек в категории (UI задаёт displayName, random прячем через префикс "__"). */
export async function uploadMediaNew(category, file, displayName) {
  const formData = new FormData();
  formData.append('category', category);
  if (typeof displayName === 'string' && displayName.trim()) {
    formData.append('displayName', displayName.trim());
  }
  formData.append('file', file);
  const response = await fetch(`${API_BASE_URL}/admin/media-upload`, {
    method: 'POST',
    headers: authHeaders(),
    body: formData,
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при загрузке');
  }
  return data;
}

export async function deleteMediaFile(category, filename) {
  const enc = encodeURIComponent(filename);
  const response = await fetch(`${API_BASE_URL}/admin/media/${category}/${enc}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при удалении');
  }
  return data;
}

/** Ведущие (только супер-админ) */
export async function getAdminsList() {
  const response = await fetch(`${API_BASE_URL}/admin/admins`, {
    headers: authHeaders(),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка');
  }
  return data;
}

export async function createAdmin({ login, password, access_media, access_slots }) {
  const response = await fetch(`${API_BASE_URL}/admin/admins`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ login, password, access_media, access_slots }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка');
  }
  return data;
}

export async function updateAdminFlags(id, { access_media, access_slots }) {
  const response = await fetch(`${API_BASE_URL}/admin/admins/${id}`, {
    method: 'PATCH',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ access_media, access_slots }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка');
  }
  return data;
}

export async function deleteAdmin(id) {
  const response = await fetch(`${API_BASE_URL}/admin/admins/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка');
  }
  return data;
}

export async function getLeadersForAssign() {
  const response = await fetch(`${API_BASE_URL}/admin/leaders`, {
    headers: authHeaders(),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка');
  }
  return data;
}

export async function assignSlotsToAdmin(slotIds, adminId) {
  const response = await fetch(`${API_BASE_URL}/admin/slots/assign-admin`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ slotIds, adminId }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка');
  }
  return data;
}

export async function patchSlot(id, body) {
  const response = await fetch(`${API_BASE_URL}/admin/slots/${id}`, {
    method: 'PATCH',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(body),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка');
  }
  return data;
}

export async function getRegistrations({ from, to } = {}) {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  const qs = params.toString();
  const response = await fetch(
    `${API_BASE_URL}/admin/registrations${qs ? `?${qs}` : ''}`,
    { headers: authHeaders() }
  );
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при получении записей');
  }
  return data;
}

/** Настройки ограничения записи (супер-админ) */
export async function getBookingSettings() {
  const response = await fetch(`${API_BASE_URL}/admin/booking-settings`, {
    headers: authHeaders(),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при получении настроек записи');
  }
  return data;
}

export async function saveBookingSettings(bookingPeriod) {
  const response = await fetch(`${API_BASE_URL}/admin/booking-settings`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ bookingPeriod }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при сохранении настроек записи');
  }
  return data;
}
